import React, { useEffect, useRef, useState } from 'react';
import { FlatList, useWindowDimensions, View } from 'react-native';
import { Button } from 'react-native-paper';
import { useForm, FormProvider } from 'react-hook-form';

import Question from './Question';
import QuestionHeader from './QuestionHeader';
import StepFormNavigation from '../components/StepFormNavigation';
import createStyles, { FORM_MAX_WIDTH } from './style';
import { isCanvas } from '@common/utils';
import { INIT_PREVIEW } from './hooks/hooks';
import { IQuestionItem } from '@nocode/types';

const PreviewCms: React.FC<any> = (props: any) => {
  const { configs, style: styleConfig, previewIndex, questions } = props;
  const methods = useForm();
  const flatlist = useRef<FlatList<any>>(null);
  const canvas = isCanvas();
  const styleSheet = createStyles(styleConfig);
  let { height, width } = useWindowDimensions();
  width = canvas ? 375 : width > FORM_MAX_WIDTH ? FORM_MAX_WIDTH : width;

  const [data, setData] = useState<Record<string, unknown>[]>([]);

  useEffect(() => {
    if (questions && questions.length) {
      setData(questions);
    } else {
      setData(INIT_PREVIEW);
    }
  }, [questions]);

  useEffect(() => {
    if (!flatlist) {
      return;
    }

    flatlist.current?.scrollToOffset({
      animated: true,
      offset: width * previewIndex,
    });
  }, [previewIndex]);

  return (
    <FormProvider {...methods}>
      <View
        style={[
          styleSheet.container,
          {
            width,
          },
        ]}
      >
        {configs.formType === 'step-form' ? (
          <QuestionHeader
            canvas={canvas}
            currentIndex={previewIndex}
            questions={data as unknown as IQuestionItem[]}
            styleConfig={styleConfig}
            configs={configs}
          />
        ) : null}
        <FlatList
          data={data}
          ref={flatlist}
          renderItem={({ item, index }) => (
            <Question
              item={item}
              index={index}
              questionMarker={configs.questionMarker}
              formType={configs.formType}
              styleConfig={styleConfig}
              width={width}
            />
          )}
          snapToAlignment="start"
          keyExtractor={(item, index) => index.toString()}
          {...(configs.formType === 'step-form'
            ? {
                getItemLayout: (item, index) => ({
                  length: height,
                  offset: width * index,
                  index,
                }),
                horizontal: true,
                pagingEnabled: true,
                initialScrollIndex: 0,
                showsHorizontalScrollIndicator: false,
              }
            : {
                initialScrollIndex: 0,
                scrollEnabled: true,
                getItemLayout: (item, index) => ({
                  length: width,
                  offset: height * index,
                  index,
                }),
              })}
          style={{
            width,
            maxWidth: FORM_MAX_WIDTH,
          }}
        />

        <View
          style={{
            display: 'flex',
            width: '100%',
            flexDirection: 'row',
            paddingHorizontal: 20,
            justifyContent: 'center',
            marginTop: 40,
          }}
        >
          {configs.formType === 'step-form' ? (
            <StepFormNavigation
              onNextButtonClick={() => {}}
              onPrevButtonClick={() => {}}
              styles={styleSheet}
              disabledBack={true}
              disabledForward={true}
            />
          ) : (
            <Button
              style={[
                styleSheet.commonButtonWrapper,
                styleSheet.submitButton,
                styleSheet.nextButtonWrapper,
              ]}
              contentStyle={styleSheet.commonButtonContent}
              labelStyle={[
                styleSheet.commonButtonLabel,
                styleSheet.nextButtonLabel,
              ]}
              onPress={() => {}}
            >
              Submit
            </Button>
          )}
        </View>
      </View>
    </FormProvider>
  );
};

export default PreviewCms;
